/**
 * Notification types whose presence in the inbox is already represented by
 * a conversation, inquiry, offer, or DM row. Filtering these out of the
 * notification stream prevents duplicate near-identical rows.
 *
 * When adding a new notification `type` (see `notify_*` DB triggers), decide
 * whether the underlying event already surfaces as its own row and, if so,
 * add the type here.
 */
export const SHADOWED_BY_CONVERSATION = [
	'inquiry_received',
	'new_offer',
	'offer_accepted',
	'offer_declined',
	'counter_offer',
	'meetup_proposed',
	'meetup_accepted',
	'meetup_declined',
	'dm_received',
	'new_message',
] as const;

export type ShadowedNotificationType = (typeof SHADOWED_BY_CONVERSATION)[number];

const SHADOW_SET: ReadonlySet<string> = new Set(SHADOWED_BY_CONVERSATION);

export const isShadowedByConversation = (t: string): t is ShadowedNotificationType =>
	SHADOW_SET.has(t);
